import {enableDebugTools, disableDebugTools} from '@angular/platform-browser';
import {enableProdMode, ApplicationRef} from '@angular/core';

declare let ENV;

// Common env directives
let PROVIDERS: any[] = [];

let DECORATEMODULEREF = function identity<T>(value: T): T {
    return value;
};

// TODO: Add debug messages
/** Setup angular environment depending on global environment */
if ('production' === ENV) {
    // Production
    disableDebugTools();
    enableProdMode();
    PROVIDERS = [ ...PROVIDERS ];
} else {

    // Development
    DECORATEMODULEREF = (modRef: any) => {
        const appRef = modRef.injector.get( ApplicationRef );
        const cmpRef = appRef.components[0];

        let NG = (<any>window).ng;
        enableDebugTools(cmpRef);
        (<any>window).ng.probe = NG.probe;
        (<any>window).ng.coreTokens = NG.coreTokens;
        return modRef;
    };
    PROVIDERS = [ ...PROVIDERS ];
}

export const decorateModuleRef = DECORATEMODULEREF;

export const ENV_PROVIDERS = [ ...PROVIDERS ];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/utils/ng-environment.ts